var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 30C23.9558 30 30 23.9558 30 16.5C30 9.04416 23.9558 3 16.5 3C9.04416 3 3 9.04416 3 16.5C3 23.9558 9.04416 30 16.5 30Z",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2356_31269)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4208 17.9999C23.1829 17.9999 23.8008 17.3821 23.8008 16.6199C23.8008 15.8578 23.1829 15.2399 22.4208 15.2399C21.6586 15.2399 21.0408 15.8578 21.0408 16.6199C21.0408 17.3821 21.6586 17.9999 22.4208 17.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3817 17.9999C12.1439 17.9999 12.7617 17.3821 12.7617 16.6199C12.7617 15.8578 12.1439 15.2399 11.3817 15.2399C10.6196 15.2399 10.0017 15.8578 10.0017 16.6199C10.0017 17.3821 10.6196 17.9999 11.3817 17.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9013 17.9999C17.6634 17.9999 18.2813 17.3821 18.2813 16.6199C18.2813 15.8578 17.6634 15.2399 16.9013 15.2399C16.1391 15.2399 15.5213 15.8578 15.5213 16.6199C15.5213 17.3821 16.1391 17.9999 16.9013 17.9999Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2356_31269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8,
    height: 2.76,
    fill: "white",
    transform: "translate(23.8008 18) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleMore);
export default __webpack_public_path__ + "static/media/circle-more.467c44d25dd0b3aaadbeddda8c36e4c1.svg";
export { ForwardRef as ReactComponent };